module.exports = __webpack_public_path__ + "pr.svg?563200c5ca16c47d8db68f101700cfb6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/pr.svg
// module id = 1572
// module chunks = 0